export const Logo = ({ compact = false }) => (
  <a href="#conteudo" data-testid="brand-logo" className="flex items-center gap-2.5 group">
    <span className="relative grid place-items-center w-10 h-10 rounded-xl bg-[#04120E] border border-[#00E676]/40 shadow-[0_0_18px_rgba(0,230,118,0.35)] transition-shadow duration-300 group-hover:shadow-[0_0_28px_rgba(0,230,118,0.6)]">
      <svg viewBox="0 0 32 32" className="w-6 h-6" aria-hidden="true">
        <path d="M22.5 6.5 12 17.5h5L10 25.5l1.8-6H8l3.5-8h11z" fill="#00E676" />
        <circle cx="23.5" cy="9" r="2.4" fill="#A3E635" />
      </svg>
    </span>
    {!compact && (
      <span className="leading-none">
        <span className="block font-heading font-extrabold text-lg tracking-tight text-white">
          iGreen <span className="text-[#00E676]">Energia</span>
        </span>
        <span className="block text-[10px] font-mono2 uppercase tracking-[0.18em] text-emerald-200/60">Lucas Marques e Aline Finger · Santa Rosa/RS</span>
      </span>
    )}
  </a>
);
